// removed by extract-text-webpack-plugin
module.exports = {"delegate-index":"style__delegate-index___1Xz7z","delegate-name":"style__delegate-name___207BJ","list":"style__list___3hRf2","list--small":"style__list--small___2Y_mM","delegate-action":"style__delegate-action___35hWV","delegate-actions":"style__delegate-actions___lN0oP","add-delegate-button":"style__add-delegate-button___2WnZF"};


//////////////////
// WEBPACK FOOTER
// ./components/DelegateList/style.scss
// module id = 1236
// module chunks = 0